module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content-wrapper",
    staticStyle: {
      "min-height": "870px"
    }
  }, [_c('vue-headful', {
    attrs: {
      "title": 'SGP - Configurações Gerais'
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "fade-transition ng-scope",
    attrs: {
      "ng-view": ""
    }
  }, [_c('section', {
    staticClass: "content-header ng-scope"
  }, [_c('h1', [_vm._v("Configurações Gerais")]), _vm._v(" "), _c('b-breadcrumb', {
    attrs: {
      "items": _vm.breadcrumb
    }
  })], 1), _vm._v(" "), _c('section', {
    staticClass: "content ng-scope"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box box-widget"
  }, [_c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading.show === true),
      expression: "loading.show === true"
    }],
    staticClass: "overlay",
    staticStyle: {
      "position": "absolute",
      "top": "0px",
      "left": "0px",
      "width": "100%",
      "height": "100%",
      "display": "block"
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh fa-spin"
  })]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "tab-content"
  }, [_c('div', {
    staticClass: "tab-pane active",
    attrs: {
      "id": "MóduloUsuáriosLogados"
    }
  }, [(_vm.usuarioLogado.userType === 'FUNDACAO') ? _c('div', {
    staticClass: "form-group"
  }, [_c('span', [_vm._v(" Usuários Logados no sistema: ")]), _vm._v(" " + _vm._s(_vm.usuariosLogados.length) + "\n                  "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('table', {
    staticClass: "table table-condensed table-bordered table-striped text-center"
  }, [_vm._m(1), _vm._v(" "), _c('thead', _vm._l((_vm.usuariosLogados), function(usuario) {
    return _c('tr', [_c('td', {
      staticClass: "text-center",
      attrs: {
        "data-title": "'nome'",
        "sortable": "'item'",
        "width": "20%"
      }
    }, [_vm._v(_vm._s(usuario.ds_nome_usuario))]), _vm._v(" "), _c('td', {
      staticClass: "text-center",
      attrs: {
        "data-title": "'login'",
        "sortable": "'login'",
        "width": "20%"
      }
    }, [_vm._v(_vm._s(usuario.ds_login))]), _vm._v(" "), _c('td', {
      staticClass: "text-center",
      attrs: {
        "data-title": "'email'",
        "sortable": "'email'",
        "width": "20%"
      }
    }, [_vm._v(_vm._s(usuario.ds_email))]), _vm._v(" "), _c('td', {
      staticClass: "text-center",
      attrs: {
        "data-title": "'tipo'",
        "sortable": "'tipo'",
        "width": "20%"
      }
    }, [_vm._v(_vm._s(usuario.ds_tipo_usuario) + "\n                        ")]), _vm._v(" "), _c('td', {
      staticClass: "text-center",
      attrs: {
        "data-title": "'email'",
        "sortable": "'email'",
        "width": "20%"
      }
    }, [(usuario.ds_tipo_usuario === 'ENTIDADE' && usuario.entidade && !_vm._.isNull(usuario.entidade)) ? _c('div', [_vm._v(_vm._s(usuario.entidade.ds_nome) + " - " + _vm._s(_vm._f("cnpj")(usuario.entidade.ds_cnpj)))]) : (usuario.ds_tipo_usuario === 'FUNDACAO') ? _c('div', [_vm._v("-")]) : _vm._e()])])
  }), 0)])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "tab-pane",
    attrs: {
      "id": "MóduloUsuario"
    }
  }, [(_vm.$root.authorize('usuario-entidade-configurar')) ? _c('div', {
    staticClass: "form-group"
  }, [_c('button', {
    staticClass: "btn btn-default pull-right",
    attrs: {
      "type": "button",
      "uib-tooltip": "Editar"
    },
    on: {
      "click": function($event) {
        _vm.mostrar.isFrmEntityUserOpen = !_vm.mostrar.isFrmEntityUserOpen
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-gears"
  })]), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('p', [_vm._v("Edita comportamentos relativos ao cadastro de usuário entidade.")])]) : _vm._e(), _vm._v(" "), (_vm.mostrar.isFrmEntityUserOpen) ? _c('div', {
    staticClass: "form-horizontal",
    attrs: {
      "name": "frmEntityUser",
      "novalidate": ""
    }
  }, [_c('div', {
    staticClass: "well well-sm no-shadow animated fadeInDownOutUp"
  }, [_c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.first('defaultProfile')
    }
  }, [_c('label', {
    staticClass: "control-label col-md-2",
    attrs: {
      "for": "active"
    }
  }, [_vm._v("Perfil padrão usuário CNPJ:")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-5"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selected),
      expression: "selected"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "defaultProfile"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.selected = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Nenhum")]), _vm._v(" "), _vm._l((_vm.perfis), function(perfil) {
    return _c('option', {
      domProps: {
        "value": perfil.ds_nome
      }
    }, [_vm._v(_vm._s(perfil.ds_nome))])
  })], 2), _vm._v(" "), (_vm.errors.first('defaultProfile')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('defaultProfile')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.first('defaultProfile')
    }
  }, [_c('label', {
    staticClass: "control-label col-md-2",
    attrs: {
      "for": "active"
    }
  }, [_vm._v("Perfil padrão usuário CPF:")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-5"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedCpf),
      expression: "selectedCpf"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "defaultProfileCpf"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.selectedCpf = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Nenhum")]), _vm._v(" "), _vm._l((_vm.perfis), function(perfil) {
    return _c('option', {
      domProps: {
        "value": perfil.ds_nome
      }
    }, [_vm._v(_vm._s(perfil.ds_nome))])
  })], 2), _vm._v(" "), (_vm.errors.first('defaultProfileCpf')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('defaultProfileCpf')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "form-group",
    staticStyle: {
      "margin-bottom": "0"
    }
  }, [_c('div', {
    staticClass: "col-md-10 col-md-offset-2"
  }, [_c('button', {
    staticClass: "btn btn-success btn-flat",
    attrs: {
      "type": "submit"
    },
    on: {
      "click": _vm.salva
    }
  }, [_c('i', {
    staticClass: "fa fa-check-circle-o",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Salvar")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default btn-flat",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.mostrar.isFrmEntityUserOpen = false
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-times-circle",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Cancelar")])])])])]) : _vm._e(), _vm._v(" "), (_vm.$root.authorize('usuario-entidade-configurar')) ? _c('hr') : _vm._e(), _vm._v(" "), (_vm.$root.authorize('usuario-agencia-configurar')) ? _c('div', {
    staticClass: "form-group"
  }) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "tab-pane",
    attrs: {
      "id": "MóduloAcoes"
    }
  }, [(_vm.$root.authorize('perfil-atribuido-configurar')) ? _c('div', {
    staticClass: "form-group"
  }, [_c('button', {
    staticClass: "btn btn-default pull-right",
    attrs: {
      "type": "button",
      "uib-tooltip": "Editar"
    },
    on: {
      "click": function($event) {
        _vm.mostrar.isFrmAssignedProfileOpen = !_vm.mostrar.isFrmAssignedProfileOpen
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-gears"
  })]), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('p', [_vm._v("Edita comportamentos relativos à atribuição de perfil.")])]) : _vm._e(), _vm._v(" "), (_vm.mostrar.isFrmAssignedProfileOpen) ? _c('div', {
    staticClass: "form-horizontal",
    attrs: {
      "name": "frmAssignedProfile",
      "novalidate": ""
    }
  }, [_c('div', {
    staticClass: "well well-sm no-shadow animated fadeInDownOutUp"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "control-label col-md-2"
  }, [_vm._v("Perfis de Gerência:")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-5 col-lg-6"
  }, [_c('multiselect', {
    attrs: {
      "options": _vm.perfis,
      "multiple": true,
      "close-on-select": false,
      "clear-on-select": true,
      "hide-selected": true,
      "preserve-search": true,
      "placeholder": "Selecione um perfil",
      "label": "ds_nome",
      "track-by": "ds_nome",
      "preselect-first": true
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(props) {
        return [_c('span', {
          staticClass: "multiselect__tag"
        }, [_c('span', [_vm._v(_vm._s(props.option.name))]), _c('span', {
          staticClass: "custom__remove",
          on: {
            "click": function($event) {
              return props.remove(props.option)
            }
          }
        }, [_vm._v("❌")])])]
      }
    }], null, false, 3413081920),
    model: {
      value: (_vm.configuracao.assignedProfileConfig.managerProfiles),
      callback: function($$v) {
        _vm.$set(_vm.configuracao.assignedProfileConfig, "managerProfiles", $$v)
      },
      expression: "configuracao.assignedProfileConfig.managerProfiles"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group",
    staticStyle: {
      "margin-bottom": "0"
    }
  }, [_c('div', {
    staticClass: "col-md-10 col-md-offset-2"
  }, [_c('button', {
    staticClass: "btn btn-success btn-flat",
    attrs: {
      "type": "submit"
    },
    on: {
      "click": _vm.salva
    }
  }, [_c('i', {
    staticClass: "fa fa-check-circle-o",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Salvar")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default btn-flat",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.mostrar.isFrmAssignedProfileOpen = false
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-times-circle",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Cancelar")])])])])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "tab-pane",
    attrs: {
      "id": "MóduloEntidade"
    }
  }, [(_vm.$root.authorize('entidade-configurar')) ? _c('div', {
    staticClass: "form-group"
  }, [_c('button', {
    staticClass: "btn btn-default pull-right",
    attrs: {
      "type": "button",
      "uib-tooltip": "Editar"
    },
    on: {
      "click": function($event) {
        _vm.mostrar.isFrmCredentialOpen = !_vm.mostrar.isFrmCredentialOpen
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-gears"
  })]), _vm._v(" "), _vm._m(4), _vm._v(" "), _c('p', [_vm._v("Edita comportamentos relativos ao credenciamento.")])]) : _vm._e(), _vm._v(" "), (_vm.mostrar.isFrmCredentialOpen) ? _c('div', {
    staticClass: "form-horizontal",
    attrs: {
      "name": "frmAssignedProfile",
      "novalidate": ""
    }
  }, [_c('div', {
    staticClass: "well well-sm no-shadow animated fadeInDownOutUp"
  }, [_c('div', {
    staticClass: "form-group required",
    class: {
      'has-error': _vm.errors.first('isSendEmail')
    }
  }, [_c('label', {
    staticClass: "control-label col-md-2",
    attrs: {
      "for": "active"
    }
  }, [_vm._v("Enviar e-mail?")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('label', {
    staticClass: "radio-inline new-control new-control-radio"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.configuracao.configuracao_entidade.bt_send_email),
      expression: "configuracao.configuracao_entidade.bt_send_email"
    }],
    attrs: {
      "type": "radio",
      "name": "isSendEmail",
      "required": ""
    },
    domProps: {
      "value": 1,
      "checked": _vm._q(_vm.configuracao.configuracao_entidade.bt_send_email, 1)
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.configuracao.configuracao_entidade, "bt_send_email", 1)
      }
    }
  }), _vm._v(" Sim"), _c('div', {
    staticClass: "new-control-indicator"
  })]), _vm._v(" "), _c('label', {
    staticClass: "radio-inline new-control new-control-radio"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.configuracao.configuracao_entidade.bt_send_email),
      expression: "configuracao.configuracao_entidade.bt_send_email"
    }],
    attrs: {
      "type": "radio",
      "name": "isSendEmail",
      "required": ""
    },
    domProps: {
      "value": 0,
      "checked": _vm._q(_vm.configuracao.configuracao_entidade.bt_send_email, 0)
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.configuracao.configuracao_entidade, "bt_send_email", 0)
      }
    }
  }), _vm._v(" Não\n                          "), _c('div', {
    staticClass: "new-control-indicator"
  })]), _vm._v(" "), (_vm.errors.first('isSendEmail')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('isSendEmail')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "control-label col-md-2",
    attrs: {
      "for": "rg"
    }
  }, [_vm._v("Conteúdo do e-mail:")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('vue-editor', {
    attrs: {
      "rows": "10",
      "cols": "105"
    },
    model: {
      value: (_vm.configuracao.configuracao_entidade.ds_email_content),
      callback: function($$v) {
        _vm.$set(_vm.configuracao.configuracao_entidade, "ds_email_content", $$v)
      },
      expression: "configuracao.configuracao_entidade.ds_email_content"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "control-label col-md-2"
  }, [_vm._v("Documentos obrigatórios:")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('multiselect', {
    attrs: {
      "options": _vm.documentos,
      "multiple": true,
      "close-on-select": false,
      "clear-on-select": true,
      "hide-selected": true,
      "preserve-search": true,
      "placeholder": "Selecione um documento",
      "label": "ds_tipo",
      "track-by": "ds_tipo"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(props) {
        return [_c('span', {
          staticClass: "multiselect__tag"
        }, [_c('span', [_vm._v(_vm._s(props.option.type))]), _c('span', {
          staticClass: "custom__remove",
          on: {
            "click": function($event) {
              return props.remove(props.option)
            }
          }
        }, [_vm._v("❌")])])]
      }
    }], null, false, 579952095),
    model: {
      value: (_vm.configuracao.configuracao_entidade.documentos_obrigatorios),
      callback: function($$v) {
        _vm.$set(_vm.configuracao.configuracao_entidade, "documentos_obrigatorios", $$v)
      },
      expression: "configuracao.configuracao_entidade.documentos_obrigatorios"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group",
    staticStyle: {
      "margin-bottom": "0"
    }
  }, [_c('div', {
    staticClass: "col-md-10 col-md-offset-2"
  }, [_c('button', {
    staticClass: "btn btn-success btn-flat",
    attrs: {
      "type": "submit"
    },
    on: {
      "click": _vm.salva
    }
  }, [_c('i', {
    staticClass: "fa fa-check-circle-o",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Salvar")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default btn-flat",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.mostrar.isFrmCredentialOpen = false
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-times-circle",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Cancelar")])])])])]) : _vm._e(), _vm._v(" "), _c('hr')]), _vm._v(" "), _c('div', {
    staticClass: "tab-pane",
    attrs: {
      "id": "MóduloProposta"
    }
  }, [(_vm.$root.authorize('proposta-configurar')) ? _c('div', {
    staticClass: "form-group"
  }, [_c('button', {
    staticClass: "btn btn-default pull-right",
    attrs: {
      "type": "button",
      "uib-tooltip": "Editar"
    },
    on: {
      "click": function($event) {
        _vm.mostrar.isFrmProposalOpen = !_vm.mostrar.isFrmProposalOpen
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-gears"
  })]), _vm._v(" "), _vm._m(5), _vm._v(" "), _c('p', [_vm._v("Edita comportamentos relativos a proposta.")])]) : _vm._e(), _vm._v(" "), (_vm.mostrar.isFrmProposalOpen) ? _c('div', {
    staticClass: "form-horizontal",
    attrs: {
      "name": "frmProposal",
      "novalidate": ""
    }
  }, [_c('div', {
    staticClass: "well well-sm no-shadow animated fadeInDownOutUp"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "control-label col-md-2",
    attrs: {
      "for": "defaultDocumentTypeDraft"
    }
  }, [_vm._v("Tipo de documento padrão Minuta:")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-5"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.configuracao.configuracao_proposta.minuta.ds_tipo),
      expression: "configuracao.configuracao_proposta.minuta.ds_tipo"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "defaultDocumentTypeDraft"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.configuracao.configuracao_proposta.minuta, "ds_tipo", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Nenhum")]), _vm._v(" "), _vm._l((_vm.documentos), function(documento) {
    return _c('option', {
      domProps: {
        "value": documento.ds_tipo
      }
    }, [_vm._v(_vm._s(documento.ds_tipo))])
  })], 2), _vm._v(" "), (_vm.errors.first('defaultDocumentTypeDraft')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('defaultDocumentTypeDraft')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "control-label col-md-2",
    attrs: {
      "for": "defaultDocumentTypeWorkPlan"
    }
  }, [_vm._v("Tipo de documento padrão Plano de Trabalho:")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-5"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.configuracao.configuracao_proposta.plano_trabalho.ds_tipo),
      expression: "configuracao.configuracao_proposta.plano_trabalho.ds_tipo"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "defaultDocumentTypeDraft"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.configuracao.configuracao_proposta.plano_trabalho, "ds_tipo", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Nenhum")]), _vm._v(" "), _vm._l((_vm.documentos), function(documento) {
    return _c('option', {
      domProps: {
        "value": documento.ds_tipo
      }
    }, [_vm._v(_vm._s(documento.ds_tipo))])
  })], 2), _vm._v(" "), (_vm.errors.first('defaultDocumentTypeWorkPlan')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('defaultDocumentTypeWorkPlan')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "control-label col-md-2"
  }, [_vm._v("Documentos obrigatórios:")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('multiselect', {
    attrs: {
      "options": _vm.documentos,
      "multiple": true,
      "close-on-select": false,
      "clear-on-select": true,
      "hide-selected": true,
      "preserve-search": true,
      "placeholder": "Selecione um documento",
      "label": "ds_tipo",
      "track-by": "ds_tipo"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(props) {
        return [_c('span', {
          staticClass: "multiselect__tag"
        }, [_c('span', [_vm._v(_vm._s(props.option.type))]), _c('span', {
          staticClass: "custom__remove",
          on: {
            "click": function($event) {
              return props.remove(props.option)
            }
          }
        }, [_vm._v("❌")])])]
      }
    }], null, false, 579952095),
    model: {
      value: (_vm.configuracao.configuracao_proposta.documentos_obrigatorios),
      callback: function($$v) {
        _vm.$set(_vm.configuracao.configuracao_proposta, "documentos_obrigatorios", $$v)
      },
      expression: "configuracao.configuracao_proposta.documentos_obrigatorios"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group",
    staticStyle: {
      "margin-bottom": "0"
    }
  }, [_c('div', {
    staticClass: "col-md-10 col-md-offset-2"
  }, [_c('button', {
    staticClass: "btn btn-success btn-flat",
    attrs: {
      "type": "submit"
    },
    on: {
      "click": _vm.salva
    }
  }, [_c('i', {
    staticClass: "fa fa-check-circle-o",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Salvar")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default btn-flat",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.mostrar.isFrmProposalOpen = false
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-times-circle",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Cancelar")])])])])]) : _vm._e(), _vm._v(" "), _c('hr')]), _vm._v(" "), _c('div', {
    staticClass: "tab-pane",
    attrs: {
      "id": "MóduloDocumentos"
    }
  }, [(_vm.$root.authorize('documento-configurar')) ? _c('div', {
    staticClass: "form-group"
  }, [_c('button', {
    staticClass: "btn btn-default pull-right",
    attrs: {
      "type": "button",
      "uib-tooltip": "Editar"
    },
    on: {
      "click": function($event) {
        _vm.mostrar.isFrmDocumentOpen = !_vm.mostrar.isFrmDocumentOpen
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-gears"
  })]), _vm._v(" "), _vm._m(6), _vm._v(" "), _c('p', [_vm._v("Permite escolher os tipos de documentos permitidos e o tamanho dos mesmos.")])]) : _vm._e(), _vm._v(" "), (_vm.mostrar.isFrmDocumentOpen) ? _c('div', {
    staticClass: "form-horizontal",
    attrs: {
      "name": "frmRequest",
      "novalidate": ""
    }
  }, [_c('div', {
    staticClass: "well well-sm no-shadow animated fadeInDownOutUp"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "control-label col-md-2 required",
    attrs: {
      "for": "fileSize"
    }
  }, [_vm._v("Tamanho máximo:")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-lg-3"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.configuracao.documento.dc_tamanho_arquivo),
      expression: "configuracao.documento.dc_tamanho_arquivo"
    }],
    staticClass: "form-control text-right",
    attrs: {
      "type": "number",
      "step": "1",
      "name": "fileSize",
      "required": ""
    },
    domProps: {
      "value": (_vm.configuracao.documento.dc_tamanho_arquivo)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.configuracao.documento, "dc_tamanho_arquivo", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "input-group-addon"
  }, [_vm._v("MB")])]), _vm._v(" "), (_vm.errors.first('fileSize')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('fileSize')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "control-label col-md-2 required"
  }, [_vm._v("Tipos de arquivos:")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-5 col-lg-3"
  }, [_c('multiselect', {
    attrs: {
      "options": _vm.configuracao.documento.tipo_arquivos,
      "multiple": true,
      "close-on-select": false,
      "clear-on-select": true,
      "hide-selected": true,
      "preserve-search": true,
      "placeholder": "Adicionar tipo",
      "label": "ds_tipo_de_documento",
      "track-by": "ds_tipo_de_documento"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(props) {
        return [_c('span', {
          staticClass: "multiselect__tag"
        }, [_c('span', [_vm._v(_vm._s(props.option))]), _c('span', {
          staticClass: "custom__remove",
          on: {
            "click": function($event) {
              return props.remove(props.option)
            }
          }
        }, [_vm._v("❌")])])]
      }
    }], null, false, 1823440105),
    model: {
      value: (_vm.mimeTypes),
      callback: function($$v) {
        _vm.mimeTypes = $$v
      },
      expression: "mimeTypes"
    }
  })], 1), _vm._v(" "), (_vm.errors.first('mime')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('mime')))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form-group",
    staticStyle: {
      "margin-bottom": "0"
    }
  }, [_c('div', {
    staticClass: "col-md-10 col-md-offset-2"
  }, [_c('button', {
    staticClass: "btn btn-success btn-flat",
    attrs: {
      "type": "submit"
    },
    on: {
      "click": _vm.salva
    }
  }, [_c('i', {
    staticClass: "fa fa-check-circle-o",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Salvar")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default btn-flat",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.mostrar.isFrmDocumentOpen = false
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-times-circle",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Cancelar")])])])])]) : _vm._e()])])])])])])])]), _vm._v(" "), _c('vue-snotify')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "nav nav-pills"
  }, [_c('li', [_c('a', {
    attrs: {
      "href": "#MóduloUsuáriosLogados",
      "data-toggle": "tab"
    }
  }, [_vm._v("Usuários Logados no Sistema")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#MóduloUsuario",
      "data-toggle": "tab"
    }
  }, [_vm._v("Módulo Usuário")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#MóduloAcoes",
      "data-toggle": "tab"
    }
  }, [_vm._v("Módulo Ações e proprietário")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#MóduloEntidade",
      "data-toggle": "tab"
    }
  }, [_vm._v("Módulo Entidade")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#MóduloProposta",
      "data-toggle": "tab"
    }
  }, [_vm._v("Módulo Proposta")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#MóduloDocumentos",
      "data-toggle": "tab"
    }
  }, [_vm._v("Módulo Documentos")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', {
    staticStyle: {
      "background-color": "#F2F3F4"
    }
  }, [_c('th', {
    staticClass: "text-center",
    attrs: {
      "width": "20%"
    }
  }, [_vm._v("Nome do usuário")]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    attrs: {
      "width": "20%"
    }
  }, [_vm._v("Login do usuário")]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    attrs: {
      "width": "20%"
    }
  }, [_vm._v("E-mail do usuário")]), _vm._v(" "), _c('th', {
    staticClass: "centro",
    attrs: {
      "width": "20%"
    }
  }, [_vm._v("Tipo do Usuário")]), _vm._v(" "), _c('th', {
    staticClass: "centro",
    attrs: {
      "width": "20%"
    }
  }, [_vm._v("Entidade")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "control-sidebar-subheading"
  }, [_c('strong', [_vm._v("Cadastro de usuário entidade")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "control-sidebar-subheading"
  }, [_c('strong', [_vm._v("Configuração de perfil atribuído")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "control-sidebar-subheading"
  }, [_c('strong', [_vm._v("Configuração de credenciamento")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "control-sidebar-subheading"
  }, [_c('strong', [_vm._v("Configuração de proposta")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "control-sidebar-subheading"
  }, [_c('strong', [_vm._v("Configuração de documentos anexos")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-a3eabc92!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/configuracoes/ConfGerais.vue
// module id = 1978
// module chunks = 2